import { render } from "./StaffDatatableFormPrices.vue?vue&type=template&id=eb639b0a"
import script from "./StaffDatatableFormPrices.vue?vue&type=script&lang=js"
export * from "./StaffDatatableFormPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__